<template>
  <div>
    <b-container fluid class="d-flex align-items-center back-wrapper">
      <b-row >
        <b-col lg="7" md="10">
          <router-link :to="{name: 'ordenes'}" class="back-item">
              <img class="arrow-back" src="img/theme/icn_arrowback.svg" alt="">
              <span>Ordenes</span>
          </router-link>
        </b-col>
      </b-row>
    </b-container>
    <div class="header pb-8 pt-5 pt-lg-6 d-flex align-items-center profile-header">
      <b-container fluid>
        <!-- Mask -->
        <span class="mask"></span>
        <!-- Header container -->
        <h1 class="text-center">Panel de Configuración</h1>
      </b-container>
    </div>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="12" class="order-xl-1">
          <card>
            <b-row align-v="center" slot="header" >
              <b-col cols="8">
                <h3 class="mb-0">Editar orden</h3>
              </b-col>
            </b-row>

            <b-form @submit.prevent="updateProfile">
              <base-alert v-if="success === true" type="success" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Bien hecho!</strong> La información de la orden se actualizó exitosamente.
              </base-alert>
              <base-alert v-if="success === false" type="danger" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Error!</strong> {{error}}
              </base-alert>
              <h6 class="heading-small text-muted mb-4">Información de la orden</h6>


              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Nombre"
                      placeholder="Nombre"
                      v-model="name"
                      name="Nombre"
                      required
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Apellido Paterno"
                      placeholder="Apellido"
                      v-model="firstLastname"
                      name="Apellido"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Apellido Materno"
                      placeholder="Apellido"
                      v-model="secondLastname"
                      name="Apellido"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6" class="mb-4">
                    <label class="form-control-label" for="">Hospital</label>
                    <multiselect
                      :key="hospital"
                      v-model="hospital"
                      :options="hospitals"
                      :show-labels="false"
                      placeholder='Selecciona el hospital a asignar'>
                    </multiselect>
                  </b-col>
                  <b-col lg="6" class="mb-4">
                    <base-input
                      type="text"
                      label="Especialidad"
                      placeholder="Especialidad"
                      v-model="specialty"
                      name="Especialidad"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6" class="mb-4">
                    <base-input
                      type="text"
                      label="Especialidad"
                      placeholder="Especialidad"
                      v-model="specialty2"
                      name="Especialidad"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Correo electrónico"
                      placeholder="mail@correo.com"
                      v-model="mail"
                      name="Correo"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Teléfono"
                      placeholder=""
                      v-model="phone"
                      name="Teléfono"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Género</label>
                    <multiselect
                      :show-labels="false"
                      v-model="gender"
                      :options="['MUJER','HOMBRE']"
                      placeholder='Selecciona el género de los artículos'
                      name="Genero"
                      required
                      >
                    </multiselect>
                  </b-col>
                </b-row>
                <b-row class="mt-lg-4">
                  <b-col lg="6">
                    <label class="form-control-label" for="">Imagen de prueba de entrega</label>
                    <img class="img-fluid" :src="receipt">
                  </b-col>
                  <b-col lg="6">
                    <b-button v-if="receipt" @click="showModal" variant="danger" class="mt-4">Borrar imagen de evidencia</b-button>
                  </b-col>
                </b-row>
                <template v-for="item in items">
                  <hr class="my-4">
                  <h6 class="heading-small text-muted mb-4">{{item.type}}</h6>
                  <b-row >
                    <b-col lg="4">
                      <base-input
                        type="text"
                        label="Cantidad"
                        placeholder="1"
                        v-model="item.qty"
                        name="Cantidad"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="4" class="mb-4">
                      <label class="form-control-label" for="">Modelo</label>
                      <multiselect
                        :show-labels="false"
                        v-model="item.model"
                        :options="optionsModelsNames"
                        placeholder='Selecciona el modelo'>
                      </multiselect>
                    </b-col>
                    <b-col lg="4" class="mb-4">
                      <label class="form-control-label" for="">Talla</label>
                      <multiselect
                        :show-labels="false"
                        v-model="item.size"
                        :options="getSizes(item.model)"
                        placeholder='Selecciona la talla del modelo'>
                      </multiselect>
                    </b-col>
                    <b-col lg="4" class="mb-4">
                      <label class="form-control-label" for="">Color</label>
                      <multiselect
                        :show-labels="false"
                        v-model="item.color"
                        :options="getColors(item.model)"
                        placeholder='Selecciona el color del modelo'>
                      </multiselect>
                    </b-col>
                    <b-col lg="4" class="mb-4">
                      <label class="form-control-label" for="">Bordado</label>
                      <multiselect
                        :show-labels="false"
                        v-model="item.embroid"
                        :options="optionsYN"
                        placeholder=''>
                      </multiselect>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="4" class="mb-4">
                      <label class="form-control-label" for="">Posición del bordado</label>
                      <multiselect
                        :show-labels="false"
                        v-model="item.embroid_position"
                        :options="optionsPositionScrub"
                        placeholder='Selecciona la posicion del bordado'>
                      </multiselect>
                    </b-col>
                    <b-col lg="4" class="mb-4">
                      <label class="form-control-label" for="">Letra del bordado</label>
                      <multiselect
                        :show-labels="false"
                        v-model="item.embroid_font"
                        :options="optionsFonts"
                        placeholder='Selecciona el tipo de letra'>
                      </multiselect>
                    </b-col>
                    <b-col lg="4" class="mb-4">
                      <label class="form-control-label" for="">Color del bordado</label>
                      <multiselect
                        :show-labels="false"
                        v-model="item.embroid_font_color"
                        :options="optionsColor"
                        placeholder='Selecciona la talla del modelo'>
                      </multiselect>
                    </b-col>
                    <b-col lg="4" class="mb-4">
                      <label class="form-control-label" for="">Imagen logotipo</label>
                      <img  class="img-fluid" :src="item.logo_image" alt=""><br>
                      {{item.logo_image}}
                    </b-col>
                  </b-row>
                </template>

              </div>
              <hr class="my-4">
              <b-button type="submit" variant="primary" class="mt-4">Guardar</b-button>
              <b-button :to="{ name: 'ordenes'}" variant="danger" class="mt-4">Cancelar</b-button>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
    <modal :show.sync="searchModalVisible"
            class="modal-search"
            id="searchModal"
            @close="closeModal"
            :centered="true"
            :show-close="true">
            ¿Estás seguro de eliminar la imagen?
            <template slot="footer">
              <button type="button"
                      class="btn btn-primary px-4"
                      @click="deleteImage">
                Aceptar
              </button>
              <b-button variant="danger"
                        class="px-4"
                        @click="searchModalVisible = false">
                Cancelar
              </b-button>

            </template>
    </modal>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import qs from 'qs'
import Modal from '@/components/Modal'

export default {
  components: {
    Multiselect,
    Modal
  },
  data() {
    return {
      searchModalVisible: false,
      name: '',
      firstLastname: '',
      secondLastname: '',
      specialty: '',
      specialty2: '',
      hospital: '',
      area: '',
      mail: '',
      phone: '',
      gender: '',
      items: [],
      hospitals: [],
      colors: [],
      brands: [],
      genders: [],
      success: '',
      error: '',
      modelsColor: [],
      optionsYN: ['Sí','No'],
      optionsColor: [
           'Negro 180',
           'Navy 066',
           'Blanco 179',
           'Plata 7011',
           'Verde 1264',
           'Rojo 050',
           'Rosa 026',
           'Azul 095 9'
      ],
      optionsPositionScrub: [
           'Frente Izquierdo',
           'Frente Derecho',
           'Manga Izquierda',
           'Manga Derecha',
           'Otro'
      ],
      optionsPositionPants: [
           'Pierna Izquierda',
           'Pierna Derecha',
           'Otro'
      ],
      optionsPositionCoat: [
           'Frente Izquierdo',
           'Frente Derecho',
           'Manga Izquierda',
           'Manga Derecha',
           'Espalda',
           'Otro'
      ],
      optionsPositionJacket: [
           'Frente Izquierdo',
           'Frente Derecho',
           'Manga Izquierda',
           'Manga Derecha',
           'Espalda',
           'Otro'
      ],
      optionsFonts: [
           'Bahaus',
           'Ballantines',
           'Block2',
           'Folio',
           'MV Boli',
           'Tahoma'
      ],
      optionsSizes: ['XXS','XS','S','M','L','XL','2XL','3XL','4XL'],
      optionsModels: [],
      optionsModelsNames: []
    }
  },
  methods: {
    closeModal(){
      this.searchModalVisible = false
    },
    showModal() { 
        this.searchModalVisible = true
    },
    async deleteImage(){
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      await axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        qs.stringify({
          api_token: this.token,
          user_id: this.user,
          option: 'delete_receipt',
          o_id: this.$route.params.orderId
        }),
      )
      .then((response) => {
        if (!response.data.error.code) {
          // this.success = true
          this.searchModalVisible = false
          this.receipt = ''
        } else {
          this.success = false
          this.error = response.data.error.description
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    async updateProfile() {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      await axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
        qs.stringify({
          api_token: this.token,
          user_id: this.user,
          option: 'edit_order',
          order_id: this.$route.params.orderId,
          order_name: this.name,
          order_firstLastname: this.firstLastname,
          order_secondLastname: this.secondLastname,
          order_specialty: this.specialty,
          order_specialty2: this.specialty2,
          order_hospital: this.hospital,
          order_area: this.area,
          order_mail: this.mail,
          order_phone: this.phone,
          order_gender: this.gender
        }),
      )
      .then((response) => {
        if (!response.data.error.code) {
          this.success = true
        } else {
          this.success = false
          this.error = response.data.error.description
        }
      })
      .catch((err) => {
        console.log(err)
      })
      for (var i = 0; i < this.items.length; i++){
        await axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
          qs.stringify({
            api_token: this.token,
            user_id: this.user,
            option: 'edit_item',
            item_id: this.items[i].id,
            item_qty: this.items[i].qty,
            item_model: this.items[i].model,
            item_size: this.items[i].size,
            item_color: this.items[i].color,
            item_embroid: this.items[i].embroid,
            item_embroid_position: this.items[i].embroid_position,
            item_embroid_font: this.items[i].embroid_font,
            item_embroid_font_color: this.items[i].embroid_font_color
          }),
        )
        .then((response) => {
          if (!response.data.error.code) {
            this.success = true
          } else {
            this.success = false
            this.error = response.data.error.description
          }
        })
        .catch((err) => {
          console.log(err)
        })
      }
    },
    getSizes(index){
        if (index) {
            return this.optionsModels.filter((x) => x.name == index).map(y => y.sharedSize)[0].map(z => z.name)
        } else {
            return ''
        }
    },
    getColors(index){
        if (index) {
            return this.optionsModels.filter((x) => x.name == index).map(y => y.sharedColor)[0].map(z => z.name)
        } else {
            return ''
        }
    }
  },
  created() {
    this.token = localStorage.getItem('token')
    this.user = localStorage.getItem('id_user')
    axios
    .post(
      process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
      qs.stringify({
        api_token: this.token,
        user_id: this.user,
        option: 'get_order',
        order_id: this.$route.params.orderId
      }),
    )
    .then((response) => {
      if (!response.data.error.code) {
        this.name = response.data.order.name
        this.firstLastname = response.data.order.first_lastname
        this.secondLastname = response.data.order.second_lastname
        this.specialty = response.data.order.specialty
        this.specialty2 = response.data.order.specialty2
        this.hospital = response.data.order.hospital
        this.area = response.data.order.area
        this.mail = response.data.order.mail
        this.phone = response.data.order.phone
        this.gender = response.data.order.gender
        this.receipt = response.data.order.receipt
        this.items = response.data.order.ownItem
        }
    })
    .catch((err) => {
      console.log(err)
    })
    axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_catalogs'}),
      )
      .then((response) => {
        if (!response.data.error.code && response.data.hospitals) {
          let temp = [], tempModel = []
          Object.keys(response.data.hospitals).map((key) => [response.data.hospitals[key]]).map(function(value) {
              temp.push(value[0].name)
          })
          this.hospitals = temp
          Object.keys(response.data.models).map((key) => [response.data.models[key]]).map(function(value) {
              tempModel.push(value[0])
          })
          this.optionsModels = tempModel
          this.optionsModelsNames = tempModel.map(x => x.name)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
};
</script>
<style></style>
